// Module
var code = "<span> <template v-if=\"type === 'current'\"> {{ getDateCurrent }} </template> <template v-else-if=\"type === 'users'\"> {{ getDate(value) }} </template> <template v-else-if=\"type === 'short-date'\"> {{ getShortDate(value) }} </template> <template v-else-if=\"type === 'short-numeric'\"> {{ getShortNumericDate(value) }} </template> </span> ";
// Exports
module.exports = code;